import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-utp-plan-agreement',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './utp-plan-agreement.component.html',
})
export class UtpPlanAgreementComponent {}
